import { render, staticRenderFns } from "./SubstudySelector.vue?vue&type=template&id=9a922338&"
import script from "./SubstudySelector.vue?vue&type=script&lang=js&"
export * from "./SubstudySelector.vue?vue&type=script&lang=js&"
import style0 from "./SubstudySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports